// © 2025 Camp Promethean, LLC. All Rights Reserved.

export function RunoffLoggerTooltipContent() {
  return (
    <div className="space-y-2.5 text-xs leading-relaxed">
      <p className="text-sm font-medium">Runoff Logger</p>
      <p>
        Log substrate runoff volume, EC, and pH by room and zone. Build a historical record for
        fertigation tuning and dry-back analysis.
      </p>
      <div>
        <p className="font-medium">How to use</p>
        <ol className="mt-1 list-decimal space-y-0.5 pl-4">
          <li>Logger — enter volume, EC, and pH for each zone measurement.</li>
          <li>Records — filter by room or zone, chart trends, and export CSV.</li>
          <li>Log consistently at the same time of day for comparable trends.</li>
        </ol>
      </div>
      <div>
        <p className="font-medium">Key features</p>
        <ul className="mt-1 list-disc space-y-0.5 pl-4">
          <li>Zone-level tracking across your facility</li>
          <li>Runoff counts feed the Arca dashboard summary</li>
          <li>Compare against Cultivation Targets for VWC and EC setpoints</li>
        </ul>
      </div>
      <p className="text-muted-foreground">
        Pair with Irrigation Simulator to model VWC response before changing shot programs.
      </p>
    </div>
  );
}
